
import { computed, defineComponent, onMounted, onUnmounted, PropType, ref } from "vue";
import { useRoute } from "vue-router/composables";
import { GoogletagSupport } from "@components/ads/googletags-support";
import CompileHtml from "@components/base/CompileHtml.vue";
import CiMediaConsent from "@components/consent/media-consent.vue";
import CiSocialEventTile from "@components/events/tile.vue";
import DirectMessageModal from "@components/messaging/direct-message.vue";
import CiInterestTags from "@components/tags/interest-tags.vue";
import { i18nInstance } from "@composables/i18n";
import { InfogramComposable } from "@composables/infogram-composable";
import { settingsService } from "@services/settings.service";

export default defineComponent({
  name: "CiContentsArticle",
  components: {
    "ci-direct-message-modal": DirectMessageModal,
    "ci-interest-tags": CiInterestTags,
    "ci-media-consent": CiMediaConsent,
    "ci-social-event-tile": CiSocialEventTile,
    CompileHtml,
  },
  props: {
    content: {
      type: Object as PropType<Contents.Content>,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute();
    const { locale } = i18nInstance;
    const languageTag = computed(() => (locale === "de" ? locale : `de-x-mtfrom-#${locale}`));
    const author = computed(() => props.content.copyright?.author);

    const event = ref<Nullable<Events.Event>>(null);

    onMounted(async () => {
      await InfogramComposable.loadInfogram();
      InfogramComposable.infogramWatchConsent();
      if (settingsService.hasFlipper("page_ads")) {
        GoogletagSupport.initInlineAds(route?.meta?.ads);
      }
      if (props.content.event) event.value = props.content.event;
    });

    onUnmounted(async () => {
      InfogramComposable.infogramUnwatchConsent();
    });

    return {
      author,
      event,
      languageTag,
      locale,
    };
  },
});
